import { useMutation } from "urql";

import { CreateFileRecommendationDocument } from "../../../graphql/generated";

export function useCreateFileRecommendation() {
  return useMutation(CreateFileRecommendationDocument);
}
